/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDataExportRoutesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListDataExportRoutesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListDataExportRoutesSecurity = {
  option1?: ListDataExportRoutesSecurityOption1 | undefined;
  option2?: ListDataExportRoutesSecurityOption2 | undefined;
};

export type ListDataExportRoutesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDataExportRoutesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListDataExportRoutesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListDataExportRoutesSecurityOption1$Outbound,
  ListDataExportRoutesSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDataExportRoutesSecurityOption1ToJSON(
  listDataExportRoutesSecurityOption1: ListDataExportRoutesSecurityOption1,
): string {
  return JSON.stringify(
    ListDataExportRoutesSecurityOption1$outboundSchema.parse(
      listDataExportRoutesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListDataExportRoutesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListDataExportRoutesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListDataExportRoutesSecurityOption2$Outbound,
  ListDataExportRoutesSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listDataExportRoutesSecurityOption2ToJSON(
  listDataExportRoutesSecurityOption2: ListDataExportRoutesSecurityOption2,
): string {
  return JSON.stringify(
    ListDataExportRoutesSecurityOption2$outboundSchema.parse(
      listDataExportRoutesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListDataExportRoutesSecurity$Outbound = {
  Option1?: ListDataExportRoutesSecurityOption1$Outbound | undefined;
  Option2?: ListDataExportRoutesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListDataExportRoutesSecurity$outboundSchema: z.ZodMiniType<
  ListDataExportRoutesSecurity$Outbound,
  ListDataExportRoutesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListDataExportRoutesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListDataExportRoutesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listDataExportRoutesSecurityToJSON(
  listDataExportRoutesSecurity: ListDataExportRoutesSecurity,
): string {
  return JSON.stringify(
    ListDataExportRoutesSecurity$outboundSchema.parse(
      listDataExportRoutesSecurity,
    ),
  );
}

/** @internal */
export type ListDataExportRoutesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDataExportRoutesRequest$outboundSchema: z.ZodMiniType<
  ListDataExportRoutesRequest$Outbound,
  ListDataExportRoutesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDataExportRoutesRequestToJSON(
  listDataExportRoutesRequest: ListDataExportRoutesRequest,
): string {
  return JSON.stringify(
    ListDataExportRoutesRequest$outboundSchema.parse(
      listDataExportRoutesRequest,
    ),
  );
}
